const INDEX_TO_HUMAN_OFFSET = 1
const FIRST_ITEM = 0

export function getLastIndex(array) {
  const lastIndex = array.length - INDEX_TO_HUMAN_OFFSET

  return lastIndex
}

export function getFirstItem(array) {
  return array[FIRST_ITEM]
}

export function getLastItem(array) {
  const lastIndex = getLastIndex(array)

  return array[lastIndex]
}

export function getNextIndex(index) {
  return index + INDEX_TO_HUMAN_OFFSET
}

export function earlyExitReduce(array, callback, earlyExitChecker, starterValue) {
  const wantedValue = array.slice().reduce((acc, next, index, iterationArray) => {
    if (earlyExitChecker(acc)) {
      // This breaks the reduce interaction
      iterationArray.splice(1)

      return acc
    }

    return callback(acc, next, index, iterationArray)
  }, starterValue)

  return wantedValue
}
